import BaseApi from "@/api/baseApi";
export default {
  fetchByStorageId(id) {
    return BaseApi.get(`/api-piglet/api/delivery-unity/v1/storage-id/${id}`)
  }
}
